module.exports = __webpack_public_path__ + "static/media/navbarlogo.7ea9b057.png";